import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import api from "../../../services/api";

interface SocketContextProps {
  messages: any[];
  addMessage: (data: any) => void;
}

const MessageSocketContext = createContext<SocketContextProps | undefined>(undefined);
interface SocketProviderProps {
  schema: any;
  children: any;
  tableType: any;
  values: any;
}
export const SocketProvider: React.FC<SocketProviderProps> = ({ children, schema,tableType,values }) => {
  const [messages, setMessages] = useState<any[]>([]);

  useEffect(() => {
    const loadInitialMessages = async () => {
      try {
        const searchParams = new URLSearchParams({
          type: tableType,
          reservation_id: values?.id,
        });
        api.get(`/comments`, searchParams).then((result: any) => {
          setMessages(result.data);
        });
      } catch (error) {
        console.error('Error fetching initial messages:', error);
      }
    };

    loadInitialMessages();
  }, []);

  useEffect(() => {
    const socket = io('https://socket-zoe.stagemporium.com');

    socket.on('message', (data:any) => {

      if (
        data.table === schema?.viewTable
        &&
        data?.data?.service_reservation_id === values?.id
      ) {
        setMessages((prev) => [...prev, data?.data]);
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const addMessage = (data: any) => setMessages((prev) => [...prev, data]);

  return (
    <MessageSocketContext.Provider
      value={{
        messages,
        addMessage,
      }}
    >
      {children}
    </MessageSocketContext.Provider>
  );
};

// Context használata egyszerű hookon keresztül
export const useSocketContext = () => {
  const context = useContext(MessageSocketContext);
  if (!context) {
    throw new Error('useSocketContext must be used within a MessageSocketProvider');
  }
  return context;
};
